import React from 'react';
import { applySnapshot, getSnapshot } from 'mobx-state-tree';
import { LoginStore } from './LoginStore';
import { NotificationStore } from './NotificationStore';
import { PagesStore } from './PagesStore';
import { UserStore } from './UserStore';
import { AppStore } from './AppStore';
import { MediaStore } from './MediaStore';

export const stores = {
  appStore: {
    instance: null,
    store: AppStore,
  },
  loginStore: {
    instance: null,
    store: LoginStore,
  },
  notificationStore: {
    instance: null,
    store: NotificationStore,
  },
  pagesStore: {
    instance: null,
    store: PagesStore,
  },
  mediaStore: {
    instance: null,
    store: MediaStore,
  },
  userStore: {
    instance: null,
    store: UserStore,
  },
};

export function getStore(name) {
  return stores[name].instance;
}

export function initStores(isServer, snapshots = null) {
  if (isServer) {
    Object.keys(stores).forEach(key => {
      const store = stores[key];
      store.instance = store.store.create({});
    });
  }
  Object.keys(stores).forEach(key => {
    const store = stores[key];
    if (store.instance === null) {
      store.instance = store.store.create({});
    }
  });
  if (snapshots) {
    Object.keys(stores).forEach(key => {
      const snapshot = snapshots[key];
      if (snapshot) {
        const store = stores[key].instance;
        applySnapshot(store, snapshot);
      }
    });
  }
  return stores;
}

export function getSnapshots(existingStores) {
  return Object.keys(stores).reduce((acc, key) => {
    acc[key] = getSnapshot(stores[key].instance);
    return acc;
  }, {});
}

const storeInstances = Object.keys(stores).reduce((acc, storeName) => {
  acc[storeName] = stores[storeName];
  return acc;
}, {});

export const AdaStoreContext = React.createContext(storeInstances);

if (global.window) {
  window.__ADA_STORES = stores;
}
